import Header from "../Header";
export default function PageLayout({children, pagetitle, icon, secondicon, url, secondiconTitle}) {
    return (
    <div className="pagelayout">
    <Header url={url} secondiconTitle={secondiconTitle} secondicon={secondicon} icon={icon} pagetitle={pagetitle}/>
    {children}
    </div>
    )
}   